function g(r, a) {
  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
    o = _ref.signal,
    e = _ref.edges;
  var t,
    l = null;
  var f = e != null && e.includes("leading"),
    h = e == null || e.includes("trailing"),
    u = function u() {
      l !== null && (r.apply(t, l), t = void 0, l = null);
    },
    m = function m() {
      h && u(), c();
    };
  var n = null;
  var d = function d() {
      n != null && clearTimeout(n), n = setTimeout(function () {
        n = null, m();
      }, a);
    },
    s = function s() {
      n !== null && (clearTimeout(n), n = null);
    },
    c = function c() {
      s(), t = void 0, l = null;
    },
    T = function T() {
      s(), u();
    },
    i = function i() {
      if (o !== null && o !== void 0 && o.aborted) return;
      for (var _len = arguments.length, p = new Array(_len), _key = 0; _key < _len; _key++) {
        p[_key] = arguments[_key];
      }
      t = this, l = p;
      var b = n == null;
      d(), f && b && u();
    };
  return i.schedule = d, i.cancel = c, i.flush = T, o !== null && o !== void 0 && o.addEventListener("abort", c, {
    once: !0
  }), i;
}
export { g as debounce };